import {DeliveryDelayComponent} from "./delivery-delay.component";

export default DeliveryDelayComponent
